import React from "react";
import SponsorsContent from "../function-components/SponsorsContent";

function Sponsors() {
  return (
    <>
      <SponsorsContent />
    </>
  );
}

export default Sponsors;
